import { ScrollReveal } from "@/components/base/ScrollAnimations";

export default function PrivacyHero() {
  return (
    <section className="relative min-h-[300px] md:min-h-[380px] flex items-center justify-center overflow-hidden bg-tie-navy">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract geometric pattern of intersecting lines and nodes representing data networks, warm earth tones with cream beige and soft amber lighting, minimal corporate background texture, no blue no green colors, horizontal composition"
          alt=""
          className="w-full h-full object-cover opacity-15"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-tie-navy/80 via-tie-navy/60 to-tie-navy/90" />
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 pt-24 pb-10 md:pb-14">
        <div className="max-w-4xl mx-auto text-center">
          <ScrollReveal>
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/10 border border-white/20 mb-5">
              <span className="text-xs md:text-sm text-white/80 font-medium tracking-wide uppercase">
                Legal
              </span>
            </div>
          </ScrollReveal>

          <ScrollReveal delay={100}>
            <h1 className="font-serif text-3xl sm:text-4xl md:text-5xl font-bold text-white leading-tight">
              Privacy Policy
            </h1>
          </ScrollReveal>

          <ScrollReveal delay={200}>
            <p className="mt-4 text-base md:text-lg text-white/70 max-w-2xl mx-auto">
              Last updated: 13 May 2026
            </p>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}